import CreatableSelect from "react-select/creatable";

const PurchaseSummarySection = ({
    tableItems,

    // Purchase details
    companyOptions,
    companyName,
    setCompanyName,
    companyLoading,
    selectStyles,
    orderedDate,
    setOrderedDate,

    // Summary
    subTotal,
    totalVat,
    grandTotal,
    formatSalesValue,

    // Submit
    submitError,
    handleSubmit,
    submitLoading
}) => {
    if (tableItems.length === 0) return null;

    return (
        <div className="bg-white rounded-lg shadow-md p-6">
            <div className="flex flex-col md:flex-row gap-8 justify-between">

                {/* Left — Purchase Details */}
                <div className="flex-1 space-y-3 max-w-sm">
                    <h3 className="text-sm font-semibold text-gray-700 uppercase tracking-wide border-b pb-2">
                        Purchase Details
                    </h3>

                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                            Company Name
                        </label>
                        <div className="text-sm w-full">
                            <CreatableSelect
                                options={companyOptions}
                                value={
                                    companyName
                                        ? { label: companyName, value: companyName }
                                        : null
                                }
                                onChange={(selectedOption) =>
                                    setCompanyName(selectedOption?.value || "")
                                }
                                isClearable
                                placeholder={
                                    companyLoading ? "Loading companies..." : "Select company"
                                }
                                styles={selectStyles}
                                isDisabled={companyLoading}
                                menuPlacement="auto"
                                menuPosition="fixed"
                                menuPortalTarget={document.body}
                            />
                        </div>
                    </div>

                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                            Purchase Date
                        </label>
                        <input
                            type="date"
                            value={orderedDate}
                            onChange={(e) => setOrderedDate(e.target.value)}
                            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm"
                        />
                    </div>
                </div>

                {/* Right — Order Summary */}
                <div className="max-w-sm w-full md:ml-auto">
                    <h3 className="text-sm font-semibold text-gray-700 uppercase tracking-wide border-b pb-2 mb-3">
                        Order Summary
                    </h3>

                    <div className="space-y-2.5 font-semibold">
                        <div className="flex justify-between text-gray-700 text-sm">
                            <span>Subtotal:</span>
                            <span>{formatSalesValue(subTotal)}</span>
                        </div>

                        <div className="flex justify-between text-gray-700 text-sm">
                            <span>VAT (13%):</span>
                            <span>{formatSalesValue(totalVat)}</span>
                        </div>

                        <div className="border-t pt-2 mt-2">
                            <div className="flex justify-between text-base text-gray-800">
                                <span>Grand Total:</span>
                                <span>{formatSalesValue(grandTotal)}</span>
                            </div>
                        </div>
                    </div>

                    {submitError && (
                        <div className="mt-4 py-2 px-3 bg-red-100 border border-red-400 text-red-700 rounded-md text-sm">
                            {submitError}
                        </div>
                    )}

                    <button
                        onClick={handleSubmit}
                        disabled={submitLoading}
                        className="mt-6 px-6 py-2 text-sm mx-auto bg-green-600 text-white font-semibold rounded-md hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-500 transition-colors disabled:opacity-60 disabled:cursor-not-allowed flex items-center justify-center gap-2"
                    >
                        {submitLoading ? (
                            <>
                                <div className="h-4 w-4 border-2 border-white border-t-transparent rounded-full animate-spin" />
                                Submitting...
                            </>
                        ) : "Submit Purchase Order"}
                    </button>
                </div>

            </div>
        </div>
    );
};

export default PurchaseSummarySection;